import { useEffect, useState } from "react";
import { edit_profile, get_sub_images } from "../../../../server/requests";
import Check from "../../../SubUsers/images/Check Icon.png";
import ErrorMessage from "../../../AlertMessage/AlertMessage";
import { translateWord,crypt,decrypt } from "../../../Util/util";
import Loading from "../../../Loading/Loading";

let time_out_alert

export default function EditProfile() {
    const user = JSON.parse(decrypt('user', localStorage.getItem('user')))

    const [subIcons, setSubIcons] = useState([])
    const [showLoading, setShowLoading] = useState(false)
    const [checked, setChecked] = useState(false)
    const [activeIconUrl, setActiveIconUrl] = useState('')
    const [alertMessage, setAlertMessage] = useState({
        type: 'success',
        show: false,
        text: ''
    })

    const [values, setValues] = useState({
        username: '',
        password: '',
        c_password: ''
    })

    useEffect(() => {
        setShowLoading(true)
        get_sub_images({}, res => {
            setShowLoading(false)
            setSubIcons(res)
        })
        setValues({
            username: user.name,
            password: user.password,
            c_password: user.password
        })
        setActiveIconUrl(user.image)

        if (user.age_restricted == 12) setChecked(true)
        else setChecked(false)

    }, [])

    const handleChange = e => {
        const { name, value } = e.target
        if (name == 'username') {
            setValues(k => ({ ...k, [name]: value }))
        } else {
            if (value.length < 5 && !isNaN(value)) {
                setValues(k => ({ ...k, [name]: value }))
            }
        }

    }

    const saveChanges = () => {
        let text_message = ''
        let type_message = ''
        const body = {
            age_restricted: checked ? 12 : 21,
            name: values.username,
            password: values.password,
            c_password: values.c_password,
            image: activeIconUrl,
            id: JSON.parse(decrypt('user', localStorage.getItem('user'))).id
        }
        if (!body.name.length || body.password.length < 4 || body.c_password.length < 4 || body.c_password != body.password) {
            type_message = 'error'
            if (!body.name.length) text_message = translateWord('Please enter your name')
            else if (body.password.length < 4) text_message = translateWord('PIN must be 4 characters')
            else if (body.c_password.length < 4) text_message = translateWord('Confirm PIN must be 4 characters')
            else text_message = translateWord('Passwords not match')

            setAlertMessage({
                show: true,
                type: type_message,
                text: text_message
            })
            clearTimeout(time_out_alert)
            time_out_alert = setTimeout(() => {
                setAlertMessage(k => ({ ...k, show: false }))
            }, 200)
        } else {

            delete body.c_password
            clearTimeout(time_out_alert)

            edit_profile(body, res => {
                const _sub_user = user
                _sub_user.image = body.image
                _sub_user.password = body.password
                _sub_user.name = body.name
                _sub_user.age_restricted = body.age_restricted
                localStorage.setItem('user',crypt('user', JSON.stringify(_sub_user)))
                type_message = 'success'
                text_message = translateWord('You successfully change your profile.')
                setAlertMessage({
                    show: true,
                    type: type_message,
                    text: text_message
                })
                time_out_alert = setTimeout(() => {
                    // setTimeout(()=>{
                    //     window.location.reload()
                    // },500)
                    setAlertMessage(k => ({ ...k, show: false }))
                }, 200)
            }, err => console.log(err))
        }


    }

    return (
        <>
            <ErrorMessage type={alertMessage.type} show={`${alertMessage.show}`} text={alertMessage.text} />
            {showLoading ?
                <Loading /> :
                <div className="main_edit_settings">
                    <h1 className={'title_edit_profile'}>{translateWord('Change your profile avatar')}:</h1>
                    <div className="main_icons_edit_profile">
                        {subIcons.map((elem, index) => {
                            return (
                                <img key={index}
                                    style={activeIconUrl == elem.url ? { boxShadow: '0 0 0 .2rem white' } : null}
                                    src={window._HOST_ + '/' + elem.url} alt=""
                                    className="image_edit_profile"
                                    onClick={() => setActiveIconUrl(elem.url)}
                                />
                            )
                        })}
                    </div>
                    <div className="register_field">
                        <div className="inputs_field">
                            <div className={"profile_name_reg"}>
                                <label htmlFor="">{translateWord('Profile Name')}:</label>
                                <input
                                    type="text"
                                    name={'username'}
                                    value={values.username}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className={"profile_Pin_reg"}>
                                <label htmlFor="">{translateWord('Profile PIN')}:<span>{translateWord('Leave blank if you don\'t want PIN')}</span></label>
                                <input
                                    type="password"
                                    name={'password'}
                                    value={values.password}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className={"profile_Pin_reg"}>
                                <label htmlFor="">{translateWord('Confirm PIN')}:<span>{translateWord('Leave blank if you don\'t want PIN')}</span></label>
                                <input
                                    type="password"
                                    name={'c_password'}
                                    value={values.c_password}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="kids_profile">
                            <div className="checked_reg" onClick={() => setChecked(!checked)}>
                                {checked ? <img src={Check} alt="" /> : null}
                            </div>
                            <div className="title_kids_reg">
                                <h3>{translateWord('Kids Profile')}</h3>
                                <p>{translateWord('If checked, only contents for kids 12 and under available')}</p>
                            </div>
                        </div>
                        <div className="buttons_register ">
                            <button onClick={saveChanges} className={'card_color'}>{translateWord('Save Changes')}</button>
                        </div>
                    </div>
                </div>
            }
        </>

    )
}